import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'start',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/Start.vue')
    }, {
        path: '/order/init',
        name: 'init-order',
        component: () => import(/* webpackChunkName: "order" */ '@/views/order/Init.vue'),
        meta: {
            title: 'Podaj swój NIP',
            requiresAuth: true
        }
    }, {
        path: '/order/delivery-address',
        name: 'delivery-address',
        component: () => import(/* webpackChunkName: "order" */ '@/views/order/DeliveryAddress.vue'),
        meta: {
            title: 'Nowe zamówienie',
            requiresAuth: true
        }
    }, {
        path: '/order/delivery-address/add',
        name: 'delivery-address-add',
        component: () => import(/* webpackChunkName: "order" */ '@/views/order/DeliveryAddress.vue'),
        meta: {
            title: 'Dodawanie kolejnego adresu dostawy',
            requiresAuth: true
        }
    }, {
        path: '/order/cart',
        name: 'cart',
        component: () => import(/* webpackChunkName: "order" */ '@/views/order/Cart.vue'),
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/order/cart/summary',
        name: 'cart-mobile-summary',
        component: () => import(/* webpackChunkName: "order" */ '@/views/order/CartMobileSummary.vue'),
        meta: {
            title: 'Twoje adresy',
            requiresAuth: true
        }
    }, {
        path: '/order/cart/week/:address',
        name: 'cart-mobile-week',
        component: () => import(/* webpackChunkName: "order" */ '@/views/order/CartMobileWeek.vue'),
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/order/checkout',
        name: 'checkout',
        component: () => import(/* webpackChunkName: "order" */ '@/views/order/Checkout.vue'),
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/regulations',
        name: 'regulations',
        component: () => import(/* webpackChunkName: "static" */ '@/views/static/Regulations.vue'),
        meta: {
            title: 'Regulamin',
            dontRedirectToCart: true
        }
    }, {
        path: '/privacy',
        name: 'privacy',
        component: () => import(/* webpackChunkName: "static" */ '@/views/static/Privacy.vue'),
        meta: {
            title: 'Polityka prywatności',
            dontRedirectToCart: true
        }
    }, {
        path: '/thank-you',
        name: 'thank-you',
        component: () => import(/* webpackChunkName: "order" */ '@/views/ThankYou.vue'),
        meta: {
            title: 'Dziękujemy za złożenia zamówienia',
            dontRedirectToCart: true
        }
    }, {
        path: '/offer/regulations',
        name: 'offer-regulations',
        component: () => import(/* webpackChunkName: "offer" */ '@/views/offer/OfferRegulations.vue'),
        meta: {
            title: 'Regulamin',
            offerMode: true,
            dontRedirectToCart: true
        }
    }, {
        path: '/offer/thank-you/accept',
        name: 'offer-thank-you-accept',
        component: () => import(/* webpackChunkName: "offer" */ '@/views/offer/OfferThankYouAccept.vue'),
        meta: {
            title: 'Dziękujemy!',
            offerMode: true,
            dontRedirectToCart: true
        }
    }, {
        path: '/offer/thank-you/reject',
        name: 'offer-thank-you-reject',
        component: () => import(/* webpackChunkName: "offer" */ '@/views/offer/OfferThankYouReject.vue'),
        meta: {
            title: 'Dziękujemy!',
            offerMode: true,
            dontRedirectToCart: true
        }
    }, {
        path: '/offer/empty',
        name: 'offer-empty',
        component: () => import(/* webpackChunkName: "offer" */ '@/views/offer/OfferEmpty.vue'),
        meta: {
            title: 'Oferta nie istnieje',
            offerMode: true,
            dontRedirectToCart: true
        }
    }, {
        path: '/offer/delivery-address/:slug',
        name: 'offer-delivery-address',
        component: () => import(/* webpackChunkName: "offer" */ '@/views/offer/OfferDeliveryAddress.vue'),
        meta: {
            title: 'Uzupełnienie danych adresowych',
            offerMode: true,
            dontRedirectToCart: true
        }
    }, {
        path: '/offer/checkout/:slug',
        name: 'offer-checkout',
        component: () => import(/* webpackChunkName: "offer" */ '@/views/offer/OfferCheckout.vue'),
        meta: {
            title: 'Twoja oferta',
            offerMode: true,
            dontRedirectToCart: true
        }
    }, {
        path: '/offer/cart/summary/:slug',
        name: 'offer-cart-mobile-summary',
        component: () => import(/* webpackChunkName: "offer" */ '@/views/offer/OfferCartMobileSummary.vue'),
        meta: {
            title: 'Twoja oferta',
            offerMode: true,
            dontRedirectToCart: true
        }
    }, {
        path: '/offer/cart/week/:slug/:address',
        name: 'offer-cart-mobile-week',
        component: () => import(/* webpackChunkName: "offer" */ '@/views/offer/OfferCartMobileWeek.vue'),
        meta: {
            title: 'Twoja oferta',
            offerMode: true,
            dontRedirectToCart: true
        }
    }, {
        path: '/offer/:slug',
        name: 'offer-cart',
        component: () => import(/* webpackChunkName: "offer" */ '@/views/offer/OfferCart.vue'),
        meta: {
            title: 'Twoja oferta',
            offerMode: true,
            dontRedirectToCart: true
        }
    }, {
        path: '/dashboard/login',
        name: 'dashboard-login',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/DashboardLogin.vue'),
        meta: {
            title: 'Logowanie',
            dontRedirectToCart: true
        }
    }, {
        path: '/dashboard/register',
        name: 'dashboard-register',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/DashboardRegister.vue'),
        meta: {
            title: 'Rejestracja',
            dontRedirectToCart: true
        }
    }, {
        path: '/dashboard/reset-password',
        name: 'dashboard-reset-password-step1',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/DashboardResetPasswordStep1.vue'),
        meta: {
            title: 'Reset hasła',
            dontRedirectToCart: true
        }
    }, {
        path: '/users/request-password-reset-token/:token',
        name: 'dashboard-reset-password-step2',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/DashboardResetPasswordStep2.vue'),
        meta: {
            title: 'Reset hasła',
            dontRedirectToCart: true
        }
    }, {
        path: '/dashboard',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Dashboard.vue'),
        children: [
            {
                path: 'logout',
                name: 'dashboard-logout'
            }, {
                path: '',
                name: 'dashboard-summary',
                component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/DashboardSummary.vue'),
                meta: {
                    title: 'Panel klienta',
                    dontRedirectToCart: true,
                    requiresAuth: true
                }
            }, {
                path: 'delivery',
                name: 'dashboard-delivery',
                component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/DashboardDelivery.vue'),
                meta: {
                    title: 'Dostawy',
                    dontRedirectToCart: true,
                    requiresAuth: true
                }
            }, {
                path: 'offers',
                name: 'dashboard-offers',
                component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/DashboardOffers.vue'),
                meta: {
                    title: 'Oferty',
                    dontRedirectToCart: true,
                    requiresAuth: true
                }
            }, {
                path: 'invoices',
                name: 'dashboard-invoices',
                component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/DashboardInvoices.vue'),
                meta: {
                    title: 'Faktury',
                    dontRedirectToCart: true,
                    requiresAuth: true
                }
            }, {
                path: 'company',
                name: 'dashboard-company',
                component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/DashboardCompany.vue'),
                meta: {
                    title: 'Faktury',
                    dontRedirectToCart: true,
                    requiresAuth: true
                }
            }, {
                path: 'company',
                name: 'dashboard-offer-thank-you-reject',
                component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/DashboardOfferThankYouReject.vue'),
                meta: {
                    title: 'Faktury',
                    dontRedirectToCart: true,
                    requiresAuth: true
                }
            }
        ]
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    // logout
    if(to.name === 'dashboard-logout') {
        store.dispatch('users/logout').then(() => {
            next({ name: 'start' })
        })
    }

    // go to dashboard if logged in
    if(to.name === 'dashboard-login' || to.name === 'start') {
        store.dispatch('users/checkTokenValidity').then(token => {
            if(token) {
                router.push({ name: 'dashboard-summary' }).catch(() => {})
            }
        }).catch(() => {})
    }

    // guard for routes with requireAuth attr
    if(to.meta.requiresAuth) {
        store.dispatch('users/checkTokenValidity').then(token => {
            if(token) {
                next()
            } else {
                router.push({ name: 'dashboard-logout' }).catch(() => {})
            }
        }).catch(() => {
            router.push({ name: 'dashboard-logout' }).catch(() => {})
        })
    } else {
        next()
    }
    // scroll to top
    window.scrollTo(0, 0)
})

export default router
